import { mapGetters } from 'vuex'

const positif = value => /^\d+$/.test(String(value)) && Number.isSafeInteger(Number(value)) && Number(value) > 0
const montantValide = value => value !== null && value !== '' && Number.isSafeInteger(Number(value)) && Number(value) >= 0
const uuidValide = value => typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)
function uuid() {
    const bytes = new Uint8Array(16)
    window.crypto.getRandomValues(bytes)
    bytes[6] = (bytes[6] & 15) | 64
    bytes[8] = (bytes[8] & 63) | 128
    const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('')
    return [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join('-')
}

export default {
    name: 'DepensePrestataire',
    data() {
        return { contexte: null, montant: '', commentaire: '', chargement: false, envoi: false,
            erreur: '', succes: null, confirmation: false, incertain: false, demande: null, lecture: 0, termine: false }
    },
    computed: {
        ...mapGetters(['activeRole', 'authInfo']),
        autorise() { return !!this.activeRole && this.activeRole.nom === 'ROLE_TRESORERIE' },
        acteur() { return this.authInfo && this.authInfo.user ? this.authInfo.user.id : null },
        detteId() {
            const id = this.$route.query.dette_id
            return typeof id === 'string' && positif(id) ? Number(id) : null
        },
        cleJournal() { return 'med003-paiement:' + this.acteur + ':' + this.detteId },
        saisieValide() {
            return this.autorise && this.contexte && positif(this.montant) && Number(this.montant) <= this.contexte.montant_max && this.commentaire.length <= 500
        }
    },
    watch: {
        detteId() { this.charger() },
        acteur() { this.charger() },
        autorise() { this.charger() }
    },
    mounted() { this.charger() },
    beforeDestroy() { this.termine = true; this.lecture++ },
    methods: {
        monnaie(value) { return Number(value).toLocaleString('fr-FR') + ' ' + (this.contexte ? this.contexte.devise : '') },
        messageErreur(error, fallback) {
            const response = error && error.response
            if (response && [401, 403].indexOf(response.status) !== -1) return 'Accès refusé. Vérifiez votre session et votre rôle de trésorerie.'
            const message = response && response.data && response.data.message
            return typeof message === 'string' ? message : fallback
        },
        async capacite() {
            const result = await this.$store.dispatch('getTresoreriePaiementAccess')
            if (!result || result.success !== true || !result.data || !result.data.access_token) throw new Error('Capacité absente')
            return result.data.access_token
        },
        contexteValide(result, id) {
            if (!result || result.success !== true || !result.dette || Number(result.dette.id) !== id || !result.ligne_budgetaire || !positif(result.ligne_budgetaire.id)) return false
            if (typeof result.devise !== 'string' || !result.devise) return false
            if (!['restant', 'disponible_budget', 'disponible_tresorerie', 'montant_max'].every(key => montantValide(result[key]))) return false
            return Number(result.montant_max) === Math.min(Number(result.restant), Number(result.disponible_budget), Number(result.disponible_tresorerie))
        },
        async charger() {
            const lecture = ++this.lecture, id = this.detteId
            this.contexte = null; this.erreur = ''; this.montant = ''; this.commentaire = ''
            this.demande = null; this.incertain = false; this.confirmation = false; this.envoi = false; this.succes = null
            if (!this.autorise || !positif(this.acteur)) { this.chargement = false; this.erreur = 'Ce paiement est réservé au rôle de trésorerie.'; return }
            if (!id) { this.chargement = false; this.erreur = 'Sélectionnez une dette prestataire depuis la page Dettes.'; return }
            this.chargement = true
            try {
                // Le journal ne contient aucun jeton ni identité patient et reste limité à cette session.
                const ancien = window.sessionStorage.getItem(this.cleJournal)
                if (ancien) {
                    const demande = JSON.parse(ancien)
                    if (demande.dette_id !== id || !positif(demande.montant) || !uuidValide(demande.requete_id) || typeof demande.commentaire !== 'string') throw new Error('Journal invalide')
                    this.demande = demande; this.incertain = true; this.confirmation = true
                    this.montant = String(demande.montant); this.commentaire = demande.commentaire
                }
                const access_token = await this.capacite()
                if (this.termine || lecture !== this.lecture) return
                const result = await this.$store.dispatch('getContextePaiementPrestataire', { dette_id: id, access_token })
                if (this.termine || lecture !== this.lecture) return
                if (!this.contexteValide(result, id)) throw new Error('Contexte incomplet')
                this.contexte = result
            } catch (error) {
                if (!this.termine && lecture === this.lecture) this.erreur = this.messageErreur(error, 'Impossible de préparer le paiement. Réessayez ou vérifiez la configuration de trésorerie.')
            } finally { if (!this.termine && lecture === this.lecture) this.chargement = false }
        },
        preparer() {
            if (this.envoi || this.incertain) return
            this.erreur = ''
            if (!this.saisieValide) { this.confirmation = false; this.erreur = 'Saisissez un montant entier positif, dans la limite du montant disponible.'; return }
            this.confirmation = true
        },
        modifier() { if (!this.envoi && !this.incertain) this.confirmation = false },
        async actualiser() {
            if (this.envoi || this.incertain) return
            const montant = this.montant, commentaire = this.commentaire, id = this.detteId, acteur = this.acteur
            await this.charger()
            if (!this.termine && this.contexte && id === this.detteId && acteur === this.acteur) { this.montant = montant; this.commentaire = commentaire }
        },
        async payer() {
            if (this.envoi || !this.autorise || !this.contexte || !this.confirmation || (!this.incertain && !this.saisieValide)) return
            const lecture = this.lecture, journal = this.cleJournal, etaitIncertain = this.incertain
            let envoye = false
            this.envoi = true; this.erreur = ''
            try {
                if (!this.demande) this.demande = { dette_id: this.detteId, montant: Number(this.montant), requete_id: uuid(), commentaire: this.commentaire.trim() }
                // Écrire avant l'envoi : même clé après un rechargement ou une réponse perdue.
                window.sessionStorage.setItem(journal, JSON.stringify(this.demande))
                const access_token = await this.capacite()
                if (this.termine || lecture !== this.lecture) return
                envoye = true
                const result = await this.$store.dispatch('payerDettePrestataire', Object.assign({}, this.demande, { access_token }))
                if (!result || result.success !== true || Number(result.dette_id) !== this.demande.dette_id || !positif(result.operation_id) || !positif(result.reglement_id) || Number(result.montant_regle) !== this.demande.montant || !montantValide(result.montant_restant)) throw new Error('Résultat incomplet')
                window.sessionStorage.removeItem(journal)
                if (this.termine || lecture !== this.lecture) return
                this.succes = result; this.demande = null; this.incertain = false; this.confirmation = false
                this.montant = ''; this.commentaire = ''
                // Relire les soldes : un rejeu a peut-être déjà été comptabilisé avant ce chargement.
                const id = this.detteId
                try {
                    const contexte = await this.$store.dispatch('getContextePaiementPrestataire', { dette_id: id, access_token })
                    if (this.termine || lecture !== this.lecture) return
                    if (!this.contexteValide(contexte, id)) throw new Error('Contexte incomplet')
                    this.contexte = contexte
                } catch (error) {
                    if (this.termine || lecture !== this.lecture) return
                    this.contexte = null
                    this.erreur = 'Le paiement est confirmé, mais les soldes actualisés n’ont pas pu être chargés. Retournez aux dettes pour les consulter.'
                }
            } catch (error) {
                if (this.termine || lecture !== this.lecture) return
                const status = error && error.response && error.response.status
                const rejetCertain = [400, 401, 403, 404, 409, 422].indexOf(status) !== -1
                this.incertain = etaitIncertain || (envoye && !rejetCertain)
                if (!this.incertain) {
                    try { window.sessionStorage.removeItem(journal) } catch (ignored) { /* Pas de paiement si stockage inaccessible avant l'envoi. */ }
                    this.demande = null; this.confirmation = false
                }
                this.erreur = this.incertain
                    ? 'Résultat du paiement à vérifier. Réessayez le même envoi ci-dessous : sa référence est conservée pour éviter un double règlement.'
                    : this.messageErreur(error, 'Le paiement n’a pas été envoyé. Vérifiez la connexion et autorisez le stockage de session dans votre navigateur.')
            } finally { if (!this.termine && lecture === this.lecture) this.envoi = false }
        }
    }
}
